<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :stripe="false"
      :selection="selection"
      right-toolbar-hide
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <!-- #ifndef OPEN-SOURCE -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessOrderPreemptGoodsSku.preemptionStatus')" prop="preemptionStatus">
            <BjSelectLov
              v-model="queryParams.preemptionStatus"
              constant-key="ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessOrderPreemptGoodsSku.sourceStatus')" prop="sourceStatus">
            <BjSelectLov
              v-model="queryParams.sourceStatus"
              constant-key="ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <!-- #endif -->
      </template>
      <template v-if="hasBtn" #startBtnGroup>
        <!-- #ifndef OPEN-SOURCE -->
        <el-button v-if="!success" type="primary" @click="onAction($t('BusinessOrderPreemptGoodsSku.reReserve'))">{{ $t('BusinessOrderPreemptGoodsSku.reReserve') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderPreemptGoodsSku.Uncamp'))">{{ $t('BusinessOrderPreemptGoodsSku.Uncamp') }}</el-button>
        <!-- #endif -->
      </template>

      <template v-slot:tableColumn>
        <!-- #ifndef OPEN-SOURCE -->
        <el-table-column prop="preemptionStatus" :label="$t('BusinessOrderPreemptGoodsSku.preemptionStatus')" width="100"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(scope.row.preemptionStatus)) }}
          </template></el-table-column
        >
        <!-- #endif -->

        <!-- <el-table-column :prop="spuName" :label="$t('goodsPage.spuName')" width="200" show-overflow-tooltip />
        <el-table-column prop="spuCode" :label="$t('goodsPage.spuCode')" width="160" /> -->
        <el-table-column prop="skuName" :label="$t('goodsPage.skuName')" width="160" />
        <el-table-column prop="skuCode" :label="$t('goodsPage.skuCode')" width="160" />

        <el-table-column prop="quantity" :label="$t('BusinessOrderPreemptGoodsSku.quantity')" width="80" />

        <!-- 是否挂起 -->
        <el-table-column prop="suspendStatus" :label="$t('BusinessOrderPreemptGoodsSku.hangUp')"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(scope.row.suspendStatus)) }}
          </template></el-table-column
        >

        <el-table-column prop="giftFlag" :label="$t('BusinessOrderPreemptGoodsSku.giveaway')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
              $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- #ifndef OPEN-SOURCE -->
        <el-table-column prop="sourceStatus" :label="$t('BusinessOrderPreemptGoodsSku.sourceStatus')"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourceStatus)) }}
          </template></el-table-column
        >
        <el-table-column prop="virtualWarehouseName" :label="$t('BusinessOrderPreemptGoodsSku.virtualWarehouseName')" min-width="120" />
        <!-- #endif -->
        <el-table-column prop="failReason" :label="$t('BusinessOrderPreemptGoodsSku.failReason')" min-width="300" />

        <!-- <el-table-column label="操作">
          <template slot-scope="props">
            <el-button type="text" @click="onPreemptSkuLineLog(props.row)">{{ $t('operationLogText') }}</el-button>
          </template>
        </el-table-column> -->
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderPreemptDetailSkuLineList',
  components: {},
  mixins: [pageMiXin],
  props: ['orderId', 'hasBtn', 'success'],
  data() {
    return {
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,

      selection: true,
      queryApi: orderApi.getPreemptionOrderSkuLineListByOrder,
      // 查询参数
      queryParams: {
        id: null,
        preemptionStatus: null,
        sourceStatus: null,
      },
      selectedRow: null,
    };
  },
  watch: {},
  created() {
    this.queryParams.id = this.orderId;
  },
  methods: {
    onPreemptSkuLineLog(row) {
      this.$emit('onPreemptSkuLineLog', row);
    },
    // #ifndef OPEN-SOURCE
    onAction(action) {
      const hasChildren = false;
      this.$emit('onAction', action, hasChildren, this.selectedRows);
    },
    // #endif
  },
};
</script>
